import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Stack,
  Alert,
} from "@mui/material";
import { useAuthContext } from "../../contexts/AuthContext";

export default function AdminLogin() {
  const { adminLogin } = useAuthContext();
  const navigate = useNavigate();

  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    const ok = adminLogin(login.trim(), password);
    if (ok) {
      navigate("/admin", { replace: true });
    } else {
      setError("Login ou senha invalidos.");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        px: 2,
        bgcolor: "#0b1120",
        background:
          "radial-gradient(900px circle at 30% 20%, rgba(37,99,235,0.14), transparent 55%), #0b1120",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          border: "1px solid rgba(255,255,255,0.10)",
          background: "rgba(255,255,255,0.04)",
          backdropFilter: "blur(18px)",
          width: "100%",
          maxWidth: 400,
        }}
      >
        <Stack component="form" onSubmit={handleSubmit} spacing={2.5}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 900, color: "#fff" }}>
              Admin
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: 13, mt: 0.4 }}>
              Painel interno ONURB PASS
            </Typography>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="Login"
            fullWidth
            autoComplete="username"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                background: "rgba(0,0,0,0.20)",
                "& fieldset": { borderColor: "rgba(255,255,255,0.14)" },
              },
            }}
          />

          <TextField
            label="Senha"
            type="password"
            fullWidth
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                background: "rgba(0,0,0,0.20)",
                "& fieldset": { borderColor: "rgba(255,255,255,0.14)" },
              },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              py: 1.4,
              borderRadius: 2,
              fontWeight: 900,
              background: "rgba(37,99,235,0.85)",
              "&:hover": { background: "rgba(37,99,235,1)" },
            }}
          >
            Entrar
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
